import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import rootReducer from "./rootReducer";
import rootSaga from "./rootSaga";
import { persistStore } from 'redux-persist';
import { 
	FLUSH,
	REHYDRATE,
	PAUSE,
	PERSIST,
	PURGE,
	REGISTER,
} from 'redux-persist';
const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
      serializableCheck: {
        // Ignore ONLY Redux Persist actions (safe)
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        // Still checks YOUR actions for serializability ✅
      },
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

// Create persistor (only affects domainConfig reducer)
export const persistor = persistStore(store);

export default store;
